import football from './football';
import hockey from './hockey';
import basket from './basket';
import baseball from './baseball';
import american_football from './american_football';
import e_football from './e_football';
import golf from './golf';
import mma from './mma';
import cricket from './cricket';

export default {
  football,
  hockey,
  basket,
  baseball,
  american_football,
  e_football,
  golf,
  mma,
  cricket,
};
